// extracted by mini-css-extract-plugin
export default {"font-renta":"FormPageRow_font-renta__E6Z8U","formPageRow":"FormPageRow_formPageRow__UmikF"};